<template>
    <v-content>
        <v-navigation-drawer right dark dense transparent persistent v-model="drawer" enable-resize-watcher fixed app width="150" v-if="isMobile">
            <v-list dense>
                <v-divider></v-divider>
                <!-- <v-list-tile ripple to="/signup">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Sign Up</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile> -->
                <!-- <v-list-tile ripple to="/pricing">
                    <v-list-tile-content class="leftnav-content-text" >
                        <v-list-tile-title>Pricing</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile> -->
                <v-list-tile ripple to="/">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Home</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple to="/careers">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Careers</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple @click="showKnowledgeHub;drawer=false">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Knowledge Hub</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple to="/contact">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Contact Us</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple @click="goToLoginPage()">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Login</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple to="/book-demo">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Book A Free Demo</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar fixed flat clipped-right :class="toolbarcolor" height="65">
            <img src="@/assets/logo/favicon200x200.png" alt="logo" @click="gotoHome">
            <h1 class="grey--text font-weight-light logotext" @click="gotoHome">Sweldo</h1>
            <h1 class="cyan--text font-weight-light logotext" @click="gotoHome">Now</h1>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <!-- <v-btn flat dark to="/signup" :color="toolbarFontColor" class="font-weight-regular">Sign Up</v-btn> -->
                <!-- <v-btn flat dark to="/pricing" :color="toolbarFontColor" class="font-weight-regular">Pricing</v-btn> -->
                <v-btn flat dark to="/" :color="toolbarFontColor" class="font-weight-regular">Home</v-btn>
                <v-btn flat dark to="/careers" :color="toolbarFontColor" class="font-weight-regular">Careers</v-btn>
                <v-btn flat dark @click="showKnowledgeHub" :color="toolbarFontColor" class="font-weight-regular">Knowledge Hub</v-btn>
                <v-btn flat dark to="/contact" :color="toolbarFontColor" class="font-weight-regular">Contact Us</v-btn>
                <v-btn flat dark @click="goToLoginPage()" :color="toolbarFontColor" class="font-weight-regular">Login</v-btn>
                <v-btn flat dark to="/book-demo" :color="toolbarFontColor" class="font-weight-bold primary--text">Book A Free Demo</v-btn>
            </v-toolbar-items>
            <v-toolbar-side-icon @click.stop="drawer=!drawer" v-if="isMobile" class="grey--text"></v-toolbar-side-icon>
        </v-toolbar>
        <v-dialog v-model="dialog" width="900">
            <legal-docs-viewer ref="refViewer" :dialog.sync="dialog"></legal-docs-viewer>
        </v-dialog>
    </v-content>
</template>
<script>

export default {
    data () {
        return {
            drawer: false,
            dialog: false,
            dialogContactUs: false,
            toolbarcolor: 'transparent',
            toolbarFontColor: "white",
            showHeaderDemoButton: false,
            dialogBookLiveTest: false,
            dialogAffiliateProgram: false,
            use_case_data: {
                type: 'Use Case',
                header: 'USE CASES',
                effectiveDate: '',
                intro: ``,
                details: [
                    {
                        title: 'Small and Medium-sized Enterprises (SMEs):',
                        description: 'A small retail store with 20 employees wants an efficient and cost-effective payroll solution.',
                        items: [
                            {
                                item: `The store's HR manager subscribes to SweldoNow and sets up employee profiles with salary details, allowances, and benefits.`
                            },
                            {
                                item: `The cloud-based nature of SweldoNow allows easy access to the system from anywhere, eliminating the need for on-premises infrastructure.`
                            },
                            {
                                item: `The self-service feature enables employees to view their payslips and leave balances independently, reducing HR administrative workload.`
                            },
                            {
                                item: `The SME appreciates the enhanced security measures to safeguard sensitive payroll data.`
                            },
                            {
                                item: `SweldoNow enables SMEs to save time and effort, improve payroll accuracy, and reduce compliance risks, allowing them to focus on core business operations and growth.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Startups and Tech Companies:',
                        description: `A tech startup with a dynamic workforce needs a scalable payroll system to adapt to its growth.`,
                        items: [
                            {
                                item: `SweldoNow accommodates the startup's changing workforce, allowing easy addition and removal of employees as the company expands or contracts.`
                            },
                            {
                                item: `The system integrates with finance tools used by the company, streamlining accounting processes and financial reporting.`
                            },
                            {
                                item: `SweldoNow's attendance and project charges features help track billable hours and allocate payroll expenses for different client projects.`
                            },
                            {
                                item: `SweldoNow provides startups and tech companies with a future-proof payroll system that grows with their business, promotes employee satisfaction, and enhances operational efficiency.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Manufacturing Companies:',
                        description: `A manufacturing company with multiple shifts and complex attendance rules seeks a payroll system that can handle unique requirements.`,
                        items: [
                            {
                                item: `SweldoNow's attendance management module handles the manufacturing company's multiple shift patterns and attendance rules effectively.`
                            },
                            {
                                item: `The system automatically calculates overtime and shift differentials, ensuring accurate payroll processing.`
                            },
                            {
                                item: `Enhanced security features prevent unauthorized access to sensitive data, a critical concern in manufacturing environments.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Service-based Businesses:',
                        description: `A service company with employees working on different client projects needs to allocate payroll expenses correctly.`,
                        items: [
                            {
                                item: `SweldoNow's project charges feature allows the service-based company to allocate payroll expenses accurately to specific client projects.`
                            },
                            {
                                item: `The system generates detailed reports that help the company analyze project costs and profitability.`
                            },
                            {
                                item: `The finance team appreciates the seamless integration with their accounting software, making financial reconciliation hassle-free.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Hospitality and Restaurant Industry:',
                        description: `A hotel chain with various departments and service charge distribution requires a payroll system that can handle gratuities.`,
                        items: [
                            {
                                item: `SweldoNow accommodates the hospitality industry's requirement for distributing service charges among employees.`
                            },
                            {
                                item: `The system's approval workflow and traceability feature ensures proper validation of service charge distribution.`
                            },
                            {
                                item: `With cloud-based access, hotel managers can review and approve payroll details from different locations.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Professional Services Firms:',
                        description: `A law firm with partners and associates needs a payroll system that can handle complex compensation structures.`,
                        items: [
                            {
                                item: `SweldoNow's compensation and benefits management module allows the law firm to set up different compensation structures for partners, associates, and support staff.`
                            },
                            {
                                item: `The system handles various deductions and contributions, including taxes and retirement plans.`
                            },
                            {
                                item: `The finance tools integration simplifies the process of generating financial reports for billing and tax purposes.<br><br>`
                            }
                        ]
                    },
                    {
                        title: 'Education Institutions:',
                        description: `A university with faculty, staff, and student employees requires a payroll system tailored to educational institutions.`,
                        items: [
                            {
                                item: `SweldoNow's access permissions feature enables the university to control data access based on roles, ensuring privacy and compliance.`
                            },
                            {
                                item: `The system handles payroll processing for faculty, staff, and part-time student employees efficiently.`
                            },
                            {
                                item: `The cloud-based self-service portal allows student employees to view their payslips and access important payroll information.<br><br>`
                            }
                        ]
                    },
                ],
                footer: `SweldoNow's versatility and feature-rich nature make it suitable for businesses of various sizes and industries in the Philippines. Whether it's an SME, startup, manufacturing company, service-based business, hospitality establishment, professional services firm, or educational institution, SweldoNow can streamline payroll processes and enhance overall efficiency.`
            }
        }
    },   
    components: {
        'legal-docs-viewer': () => import("@/components/LegalDocsViewer"),
    },
    methods: {
        showProductDemo() {
            window.open("https://help.sweldonow.ph/demo/")
        },
        gotoHome() {
            this.$router.push('/')
        },
        showKnowledgeHub() {
            window.open("https://help.sweldonow.ph")
        },
        goToLoginPage() {
            window.open("https://app.sweldonow.ph")
        },  
        showConfirmation() {
            this.dialogConfirmation = true
        },
        handleScroll (event) {    
            if (window.scrollY >= 350) 
                this.showHeaderDemoButton = true
            else 
                this.showHeaderDemoButton = false

            if (window.scrollY >= 130) {
                this.toolbarcolor = 'blue-grey darken-4' 
            }
            else 
            {
                this.toolbarcolor = 'transparent'
            }
                
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        bookNow() {
            return this.isMobile?'Free demo':'Book now for Free demo'
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>
<style>
img {
    height:30px;
    width:28px;
    margin-right:5px;
    cursor:pointer;
}
.logotext {
    font-family:Roboto;
    cursor:pointer;
    margin-top:10px;    
}
</style>